/**
 * 나눔터 공유 진행 상태.
 * 연타로 API가 두 번 나가지 않게 잠그고, 성공·실패 토스트는 고정 한글만 쓴다.
 */

import { useCallback, useRef, useState } from 'react';
import {
  notifyGalleryShareFailure,
  notifyGalleryShareSuccess,
} from '../utils/galleryShareFeedback';

export default function useGalleryShare({ requestShare, showToast, onView } = {}) {
  const [isSharing, setIsSharing] = useState(false);
  const inFlightRef = useRef(false);
  const requestShareRef = useRef(requestShare);
  const showToastRef = useRef(showToast);
  const onViewRef = useRef(onView);
  requestShareRef.current = requestShare;
  showToastRef.current = showToast;
  onViewRef.current = onView;

  const share = useCallback(async (item, { silent = false, confirm } = {}) => {
    if (inFlightRef.current) return undefined;
    inFlightRef.current = true;
    try {
      if (!silent && typeof confirm === 'function') {
        const ok = await confirm(item);
        if (!ok) return undefined;
      }
      setIsSharing(true);
      try {
        const result = await requestShareRef.current(item);
        if (!silent) {
          notifyGalleryShareSuccess(showToastRef.current, {
            galleryId: result?.id,
            onView: onViewRef.current,
          });
        }
        return result;
      } catch (error) {
        if (!silent) {
          notifyGalleryShareFailure(showToastRef.current);
        }
        throw error;
      } finally {
        setIsSharing(false);
      }
    } finally {
      inFlightRef.current = false;
    }
  }, []);

  return { share, isSharing };
}
